import { Component, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { UploadService } from './upload.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { AdminService } from '@app/admin/admin.service';
import { UtilService } from '../services/util.service';
import { AddOrEditService } from '../table/addOrEdit.service';
import { DomSanitizer } from '@angular/platform-browser';



export enum constants {
  BLUEPRINT = 'Blueprint',
  ASSESSMENT_PLAN = 'Assessment Plan'
}


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
    imports: [FormsModule, ReactiveFormsModule, MatDialogModule, MatButtonModule, MatIconModule, MatProgressBarModule],
    selector: 'app-uploadfiles',
    templateUrl: './uploadfiles.component.html',
    styleUrls: ['./uploadfiles.component.scss']
})
export class UploadfilesComponent implements OnInit {
  readonly constants: typeof constants = constants;
  selectedFiles?: FileList;
  progressInfos: any[] = [];
  message: string[] = [];
  fileInfos?: Observable<any>;
  files: any[] = [];
  remarks: string;
  downloadedFiles :any= {};
  bluePrint : string;
  file_to_download : string;
  assessment_plan : string;
  file_key : string;
  name:string;
  isLoading:boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public uploadService: UploadService,
    private adminService: AdminService,
    private addOrEditService: AddOrEditService,
    private util: UtilService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.downloadFile();
    if(this.data.title == 'Blueprint')
    {
      this.file_to_download ='blueprint';
    }
    else{
      this.file_to_download ='assessment_plan';
    }
  }
  selectFiles(event): void {
    this.message = [];
    this.progressInfos = [];
    this.selectedFiles = event.target.files;
  }

  downloadedFile: { url: string; name: string } | null = null; // Variable to store the file URL and name

  downloadFile(): void {
    // Start loading spinner
    this.isLoading = true;

    this.adminService.getCourseVersionDetail(this.data.id).subscribe({
      next: (data: any) => {
        //(data.body.responseBody, "courseVersionData");

        this.bluePrint = data.body.responseBody[0].blueprint;
        this.assessment_plan = data.body.responseBody[0].assessment_plan[0];

        this.file_key = this.file_to_download === 'blueprint' ? this.bluePrint : this.assessment_plan;

        this.adminService
          .downloadcourse_version_assessmentPlan_bluePrint(
            this.file_key,
            'download_course_version_bluePrint_assessment_plan'
          )
          .subscribe({
            next: (response: any) => {
              //("Download API response received:", response);

              const fileBuffer = response.body.responseBody.url;

              if (fileBuffer) {
                try {
                  const fileBlob = new Blob([new Uint8Array(fileBuffer.data)], {
                    type: 'application/octet-stream',
                  });
                  const fileUrl = window.URL.createObjectURL(fileBlob);

                  // Extract the file extension from the file_key
                  const fileExtension = this.file_key.split('.').pop() || 'png';
                  const fileName = `${this.file_to_download}.${fileExtension}`;

                  // Sanitize the Blob URL
                  const sanitizedUrl = this.sanitizer.bypassSecurityTrustUrl(fileUrl) as unknown as string;
                  this.downloadedFile = {
                    url: sanitizedUrl,
                    name: fileName,
                  };

                  //("File ready for download:", this.downloadedFile);
                } catch (error) {
                  console.error("Error processing file buffer:", error);
                }
              } else {
                console.error("File buffer is missing in the response");
              }

              // Stop loading spinner
              this.isLoading = false;
            },
            error: (err: any) => {
              console.error('Error fetching file buffer:', err);

              // Stop loading spinner
              this.isLoading = false;
            },
          });
      },
      error: (err: any) => {
        console.error('Error fetching course version details:', err);

        // Stop loading spinner
        this.isLoading = false;
      },
    });
  }
  
  
  
  
  
  
  
  uploadFiles(): void {
    this.message = [];

    if (this.selectedFiles) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.upload(i, this.selectedFiles[i]);
      }
    }
  }

  upload(idx: number, file: File): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };
    if (file) {
      let reader = new FileReader();
      reader.onload = () => {
        let reqBody = {
          folder: this.data.type,
          file: String(reader.result),
        };
        this.adminService.uploadIimage(reqBody).subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progressInfos[idx].value = Math.round(
                (100 * event.loaded) / event.total
              );
            } else if (event instanceof HttpResponse) {
              const response = event.body.responseBody;
              const msg = 'Uploaded the file successfully: ' + file.name;
              this.message.push(msg);
              this.files.push(response.url)
            }
          },
          error: (err: any) => {
            this.progressInfos[idx].value = 0;
            const msg = 'Could not upload the file: ' + file.name;
            this.message.push(msg);
          },
        });
      };
      reader.onerror = function (error) {
        //('Error: ', error);
      };
      reader.readAsDataURL(file);
    }
  }

  saveFile() {
    let postData: any;
    if (this.data.title === constants.BLUEPRINT) {
      postData = {
        id: this.data.id,
        blueprint: this.files[0]
      }
    } else {
      postData = {
        id: this.data.id,
        assessmentPlan: this.files,
        remarks: this.remarks
      }
    }
    this.addOrEditService.addOrEdit('courseVersion', postData).subscribe((data: any) => {
      const responseHead = data.body.responseHead;
      const successMsg = responseHead ? this.util.getSuccessMessage(`DOCUMENT_UPLOAD`, responseHead.statusCode, responseHead.statusDesc) : responseHead;
      this.util.simpleDialog({
        title: 'Added',
        message: `${successMsg}`,
      });
      this.dialog.closeAll();
    }, (err: any) => {
      this.util.showLoader = false;
      const serviceError = err.responseHead 
        ? this.util.getIntlErrorMessage("IMAGE_UPLOAD", err.responseHead.statusCode, err.responseHead.statusDesc)
        : err;
      this.util.simpleDialog({
        title: 'Error',
        message: `${serviceError}`,
      });
    });
  }
}
